import {logger, ObjUtil, Time, UIUtil, Util} from 'yougile-util'
import {ChatMessage, DataObjectId, Hub} from 'yougile-model'
import {Backend} from '../../common/backend'
import {globals} from '../extensions/globals-base'
import {Sync} from './sync'

type LogType = 'post-message' | 'skip-message' | 'error'

interface LogItem {
  type: LogType
  error?: {
    message: string
    url: string
    line: number
  }
  message?: {
    missing: boolean
    hubId: DataObjectId
    companyId: DataObjectId
    msg: ChatMessage
  }
  skip?: {
    reason: string
    hubId: DataObjectId
    companyId: DataObjectId
  }
}

export class ClientLogger {
  private static items: {[timestamp: number]: LogItem} = {}
  private static initializedAlready = false

  private static addItem(item: LogItem): void {
    ClientLogger.items[Date.now()] = Util.clone(item)
  }

  public static showLog(): void {
    Object.keys(ClientLogger.items)
      .sort((a, b) => +a - +b)
      .forEach(t =>
        logger.log(
          Time.formatDateTime(+t, false, true),
          ClientLogger.items[+t].type,
          ClientLogger.items[+t]
        )
      )
  }

  public static saveToFile(): void {
    UIUtil.downloadAsJson('yougile-log.json', ClientLogger.items)
  }

  public static logMessage(hub: Hub, message: ChatMessage): void {
    ClientLogger.addItem({
      type: 'post-message',
      message: {
        companyId: hub.companyId,
        hubId: hub.id,
        missing: false,
        msg: message
      }
    })
  }

  public static skipMessage(hub: Hub, reason: string): void {
    ClientLogger.addItem({
      type: 'skip-message',
      skip: {
        companyId: hub.companyId,
        hubId: hub.id,
        reason
      }
    })
  }

  private static cleanOldItems(): void {
    const oldTime = Date.now() - 72 * 3600_000
    ObjUtil.forEach(ClientLogger.items, t => {
      if (t < oldTime) {
        delete ClientLogger.items[t]
      }
    })
  }

  public static checkMissingMessages(): void {
    ObjUtil.forEach(ClientLogger.items, (t, l) => {
      if (l.type === 'post-message' && l.message && !l.message.missing) {
        const box = Sync.get({companyId: l.message.companyId})
        const hub = box?.get(l.message.hubId) as Hub
        const msg = hub?.chat?.messages?.get(l.message.msg.timestamp)
        if (!msg) {
          l.message.missing = true
          logger.warn('Found missing message', t)
          Backend.report(
            `Found missing message ${globals.currentUserId} ${t} ${hub?.title} ${l.message.companyId} ${l.message.msg.text}`
          )
        }
      }
    })
  }

  public static init(): void {
    if (this.initializedAlready) {
      return
    }
    this.initializedAlready = true

    setInterval(() => Util.catch(() => ClientLogger.cleanOldItems()), 600_000)
    setInterval(
      () => Util.catch(() => ClientLogger.checkMissingMessages()),
      500_000
    )
    document.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.ctrlKey && e.altKey && e.shiftKey && e.code === 'KeyL') {
        ClientLogger.saveToFile()
      }
    })
    window.onerror = (message: string, url, line) => {
      ClientLogger.addItem({type: 'error', error: {message, url, line}})
    }
  }
}
